import { render, staticRenderFns } from "./addTopic.vue?vue&type=template&id=311a6b5b&scoped=true&"
import script from "./addTopic.vue?vue&type=script&lang=js&"
export * from "./addTopic.vue?vue&type=script&lang=js&"
import style0 from "./addTopic.vue?vue&type=style&index=0&id=311a6b5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311a6b5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('311a6b5b')) {
      api.createRecord('311a6b5b', component.options)
    } else {
      api.reload('311a6b5b', component.options)
    }
    module.hot.accept("./addTopic.vue?vue&type=template&id=311a6b5b&scoped=true&", function () {
      api.rerender('311a6b5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/famousPerson/famousPersonMent/components/addTopic.vue"
export default component.exports